import './App.css';
import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Home from './components/Home';
import CorporateSponsorship from './components/CorporateSponsorship';
import AboutUs from './components/AboutUs';
import OurPurpose from './components/OurPurpose';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  useEffect(() => {
    // Add smooth scrolling to HTML
    document.documentElement.style.scrollBehavior = 'smooth';

    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/corporate-sponsorship" element={<CorporateSponsorship />} />
        <Route path="/our-purpose" element={<OurPurpose />} />
      </Routes>
    </Router>
  );
}

export default App;
